import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TablePersistenceService {
  constructor() {}

  saveColumns(tableKey: string, columns: string[]): void {
    localStorage.setItem(`cols_config_${tableKey}`, JSON.stringify(columns));
  }

  getColumns(tableKey: string): string[] | null {
    const data = localStorage.getItem(`cols_config_${tableKey}`);
    try {
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }

  saveCriteria(tableKey: string, criteria: any): void {
    localStorage.setItem(`criteria_search_${tableKey}`, JSON.stringify(criteria));
  }

  getCriteria(tableKey: string): any | null {
    const data = localStorage.getItem(`criteria_search_${tableKey}`);
    try {
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  }

  clearCriteria(tableKey: string): void {
    localStorage.removeItem(`criteria_search_${tableKey}`);
  }
}
